import { Button, Checkbox, Col, Form, Modal, Row, Spin, Input } from 'antd';
import { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import BreadCrumbs from '../../../../common/components/Breadcrumbs';
import { validateMessages } from '../../../../common/constants/common';
import { Page } from '../../../../common/constants/pageAction';
import { getObjectForUpdateMultiple } from '../../../../common/helperFunction';
import { IConfigSoftwareProduct } from '../../../../services/master/configSoftwareProduct/configSoftwareProduct.model';
import { useAppSelector, useAppDispatch } from '../../../../store/app.hooks';
import { updateMultiple } from '../../../../store/common/common.action';
import {
  clearMultipleUpdateMessages,
  commonSelector,
} from '../../../../store/common/common.reducer';
import {
  getConfigSoftwareProductById,
  saveConfigSoftwareProduct,
} from '../../../../store/master/configSoftwareProduct/configSoftwareProduct.action';
import {
  clearConfigSoftwareProductGetById,
  clearConfigSoftwareProductMessages,
  configSoftwareProductSelector,
} from '../../../../store/master/configSoftwareProduct/configSoftwareProduct.reducer';
import { IAddConfigSoftwareProductProps } from './addConfigSoftwareProduct.model';

const AddConfigSoftwareProductModal: React.FC<IAddConfigSoftwareProductProps> = (props) => {
  const configSoftwareProduct = useAppSelector(configSoftwareProductSelector);
  const common = useAppSelector(commonSelector);
  const dispatch = useAppDispatch();
  const { id, showModal, handleModalClose, refreshDataTable, isMultiple, valuesForSelection } =
    props;

  const isNew: boolean = id || isMultiple ? false : true;
  const title = useMemo(() => {
    return (
      <>
        {isNew ? 'Add ' : 'Edit '} <BreadCrumbs pageName={Page.ConfigSoftwareProduct} level={1} />
      </>
    );
  }, [isNew]);
  const submitButtonText = useMemo(() => {
    return isNew ? 'Save' : 'Update';
  }, [isNew]);

  const [form] = Form.useForm();

  let initialValues: IConfigSoftwareProduct = {
    product: '',
  };

  const onFinish = (values: any) => {
    const inputValues: IConfigSoftwareProduct = {
      ...values,
      id: id ? +id : null,
    };
    if (!isMultiple) {
      dispatch(saveConfigSoftwareProduct(inputValues));
    } else {
      const result = getObjectForUpdateMultiple(
        valuesForSelection,
        inputValues,
        configSoftwareProduct.search.tableName
      );
      if (result) {
        dispatch(updateMultiple(result));
      }
    }
  };

  const fillValuesOnEdit = async (data: IConfigSoftwareProduct) => {
    if (data) {
      initialValues = {
        product: data.product,
      };
      form.setFieldsValue(initialValues);
    }
  };

  useEffect(() => {
    if (configSoftwareProduct.save.messages.length > 0) {
      if (configSoftwareProduct.save.hasErrors) {
        toast.error(configSoftwareProduct.save.messages.join(' '));
      } else {
        toast.success(configSoftwareProduct.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearConfigSoftwareProductMessages());
    }
  }, [configSoftwareProduct.save.messages]);

  useEffect(() => {
    if (common.save.messages.length > 0) {
      if (common.save.hasErrors) {
        toast.error(common.save.messages.join(' '));
      } else {
        toast.warn(common.save.messages.join(' '));
        handleModalClose();
        refreshDataTable();
      }
      dispatch(clearMultipleUpdateMessages());
    }
  }, [common.save.messages]);

  useEffect(() => {
    if (+id > 0 && configSoftwareProduct.getById.data) {
      const data = configSoftwareProduct.getById.data;
      fillValuesOnEdit(data);
    }
  }, [configSoftwareProduct.getById.data]);

  useEffect(() => {
    if (+id > 0) {
      dispatch(getConfigSoftwareProductById(+id));
    }
    return () => {
      dispatch(clearConfigSoftwareProductGetById());
    };
  }, [dispatch]);

  return (
    <>
      <Modal
        wrapClassName="custom-modal"
        title={title}
        centered
        visible={showModal}
        onCancel={handleModalClose}
        footer={false}
      >
        {configSoftwareProduct.getById.loading ? (
          <div className="spin-loader">
            <Spin spinning={configSoftwareProduct.getById.loading} />
          </div>
        ) : (
          <Form
            form={form}
            name="configSoftwareProduct"
            initialValues={initialValues}
            onFinish={onFinish}
            validateMessages={validateMessages}
          >
            <Row gutter={[30, 15]} className="form-label-hide">
              <Col xs={24} sm={12} md={8}>
                <div className="form-group m-0">
                  {isMultiple ? (
                    <Form.Item name={['checked', 'product']} valuePropName="checked" noStyle>
                      <Checkbox>Product</Checkbox>
                    </Form.Item>
                  ) : (
                    'Product'
                  )}
                  <Form.Item
                    name="product"
                    label="Product"
                    className="m-0"
                    rules={[{ required: !isMultiple, max: 255 }]}
                  >
                    <Input className="form-control" />
                  </Form.Item>
                </div>
              </Col>
            </Row>
            <div className="btns-block modal-footer">
              <Button
                key="submit"
                type="primary"
                htmlType="submit"
                loading={configSoftwareProduct.save.loading || common.save.loading}
              >
                {submitButtonText}
              </Button>
              <Button key="back" onClick={handleModalClose}>
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </>
  );
};
export default AddConfigSoftwareProductModal;
